import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { SmartForm, CustomTable, CTAButtons } from 'components';
import { saveUser, getUsers, getUserGroups } from 'rdx/users';
import { formHasBeenTouched } from 'utils';

import * as schemas from './schemas';

import './posUsers.sass';

function PosUsers() {
  const dispatch = useDispatch();
  const userRef = React.createRef(null);
  const [user, setUser] = useState({});

  const users = useSelector(getUsers);
  const userGroups = useSelector(getUserGroups);

  const navigate = useNavigate();

  const options = {
    userGroupID: [
      'Select group',
      ...userGroups.map((group) => ({
        value: group.userGroupID,
        name: group.name,
      })),
    ],
  };

  const handleUserSubmit = async (values) => {
    //  if first submit failed, user would have the employeeID of the
    //  successfully created employee so new repeating one would not be added
    setUser({ ...user, ...values });
    //  employeeID would only be returned
    //  if the employee was saved but the user request failed
    const employeeID = await dispatch(
      saveUser({ ...values, employeeID: user.employeeID }, () => {
        setUser({});
      }),
    );
    if (employeeID) {
      setUser({ ...values, employeeID });
    }
  };

  const forceFormSubmit = () => userRef.current.submitForm();

  const onNext = () => {
    if (formHasBeenTouched(userRef.current)) {
      userRef.current.submitForm();
    }
    navigate('/setup/import-products');
  };

  const onClose = () => {
    if (formHasBeenTouched(userRef.current)) {
      userRef.current.submitForm();
    }
    navigate('/setup/pos-locations');
  };

  const buttons = {
    close: {
      onClick: onClose,
    },
    next: {
      onClick: onNext,
    },
  };

  return (
    <div className="pos-users d-flex flex-fill flex-column">
      <SmartForm
        options={options}
        ref={userRef}
        state={user}
        fields={schemas.userForm}
        handleSubmit={handleUserSubmit}
      />
      <div className="d-flex justify-content-end mb-3">
        <Button onClick={forceFormSubmit}>Add user</Button>
      </div>
      <CustomTable
        bordered
        striped
        columns={schemas.usersTable}
        data={users.map((item) => ({
          ...item,
          name: `${item.firstName} ${item.lastName}`,
        }))}
      />
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default PosUsers;
